import { CameraPosition } from "./types";
import { rotateY } from "./utils";

interface CameraPositionsProps {
  cameraPositions: CameraPosition[];
  loadedImageIndex: number | false;
  debugCameraPositions: boolean;
  transformCameraPosition: (
    position: [number, number, number],
    currentCameraPosition: [number, number, number],
    scaleFactor?: number,
    offset?: [number, number, number]
  ) => [number, number, number];
}

const CameraPositions = ({
  cameraPositions,
  loadedImageIndex,
  debugCameraPositions,
  transformCameraPosition,
}: CameraPositionsProps) => {
  if (
    cameraPositions.length === 0 ||
    loadedImageIndex === null ||
    loadedImageIndex === false
  ) {
    return null;
  }

  const imageIndex = loadedImageIndex as number;
  const currentCameraPos =
    cameraPositions[imageIndex]?.position ||
    ([0, 0, 0] as [number, number, number]);

  const cameraElements = cameraPositions
    .map((cam, idx) => {
      // Show next 3 and previous 2 frames
      const frameOffset = idx - imageIndex;
      const shouldShowCircle =
        frameOffset >= -2 && frameOffset <= 3 && frameOffset !== 0;

      if (!shouldShowCircle) {
        return null; // Don't render circles for distant frames or current frame
      }

      const rawPosition = transformCameraPosition(
        cam.position,
        currentCameraPos,
        0.5,
        [0, -1, 0]
      );

      const scaledPosition = rotateY(rawPosition, 90);

      // Debug logging for frame mapping
      if (debugCameraPositions) {
        // eslint-disable-next-line no-console
        console.log(
          `Frame ${idx}: ${
            cam.frameName
          } - Offset: ${frameOffset} - Position: [${scaledPosition.join(", ")}]`
        );
      }

      return (
        <a-entity key={cam.frameName}>
          {/* Circle for camera position - made more visible */}
          <a-entity
            data-frame-index={idx}
            geometry="primitive: sphere; radius: 0.07"
            material="color: #0088ff; opacity: 0.8; transparent: true"
            position={scaledPosition.join(" ")}
            class="clickable"
            animation__mouseenter="property: scale; to: 1.5 1.5 1.5; startEvents: mouseenter; dur: 300; easing: easeOutElastic"
            animation__mouseleave="property: scale; to: 1 1 1; startEvents: mouseleave; dur: 300; easing: easeOutElastic"
            title={`${cam.frameName} (Index: ${idx}, Offset: ${
              frameOffset > 0 ? "+" : ""
            }${frameOffset}) - Click to navigate`}
          />

          {/* Frame name label in debug mode */}
          {debugCameraPositions && (
            <a-text
              value={`${cam.frameName}\n(${idx}, ${
                frameOffset > 0 ? "+" : ""
              }${frameOffset})`}
              position={`${scaledPosition[0]} ${scaledPosition[1] + 0.4} ${
                scaledPosition[2]
              }`}
              color="#ffffff"
              align="center"
              scale="0.6 0.6 0.6"
              billboard="true"
            />
          )}
        </a-entity>
      );
    })
    .filter(Boolean);

  return (
    <>
      {cameraElements}
      {/* Path connecting camera positions using a-curve and a-tube */}
      {/* {cameraPositions.length > 1 && !debugCameraPositions && (
        <>
          <a-curve id="cameraPath">
            {cameraPositions
              .filter((cam, idx) => {
                const frameOffset = idx - imageIndex;
                return frameOffset >= -2 && frameOffset <= 3;
              }) // Only include nearby frames in path
              .map((cam, idx) => {
                const scaledPosition = transformCameraPosition(
                  cam.position,
                  currentCameraPos,
                  0.5,
                  [0, -1, 0]
                );
                return (
                  <a-curve-point
                    key={idx}
                    position={scaledPosition.join(" ")}
                  />
                );
              })}
          </a-curve>
          <a-tube
            curve="#cameraPath"
            radius="0.05"
            material="color: #00aaff; opacity: 0.4; transparent: true"
          />
        </>
      )} */}
    </>
  );
};

export default CameraPositions;
